var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Master Data") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.4,64.3c-17,0-30.8,13.8-30.8,30.8c0,2.4,0.3,4.8,0.8,7L182,122.1c-4.4-8-11.3-14.5-19.5-18.5l16.7-47.3  c0.6,0.1,1.2,0.1,1.8,0.1c11.1,0,20.2-9.1,20.2-20.2S192.1,16,180.9,16s-20.2,9.1-20.2,20.2c0,7,3.6,13.2,9,16.8L153,100.3  c-3.2-0.7-6.6-1.1-10-1.1c-7.1,0-13.8,1.7-19.8,4.6L107.9,80c5.5-5.1,9-12.5,9-20.6c0-15.5-12.6-28.2-28.2-28.2S60.5,43.9,60.5,59.4  s12.6,28.2,28.2,28.2c3.8,0,7.5-0.8,10.8-2.2l15.3,23.8c-7.4,6-12.8,14.3-15.1,23.9l-59-7.6c-1.4-7.4-8-13.1-15.8-13.1  c-8.9,0-16.1,7.2-16.1,16.1s7.2,16.1,16.1,16.1c6.4,0,11.9-3.8,14.5-9.2l59,7.6c0,0.2,0,0.5,0,0.7c0,10.9,3.9,20.8,10.4,28.6  l-42.7,44.8c-5.5-3.9-12.1-6.1-19.3-6.1c-18.5,0-33.6,15.1-33.6,33.6s15.1,33.6,33.6,33.6c18.5,0,33.6-15.1,33.6-33.6  c0-7.8-2.6-14.9-7.1-20.6l42.7-44.8c6.2,4.7,13.6,7.8,21.7,8.8l-1.5,26.7c-6.6,2-11.3,8.2-11.3,15.4c0,8.9,7.2,16.1,16.1,16.1  c8.9,0,16.1-7.2,16.1-16.1c0-7-4.5-13-10.9-15.2l1.5-26.8c5.4-0.6,10.5-2.1,15.2-4.5l43.2,66.6c-3.3,3.6-5.4,8.4-5.4,13.7  c0,11.1,9.1,20.2,20.2,20.2s20.2-9.1,20.2-20.2s-9.1-20.2-20.2-20.2c-2.3,0-4.4,0.4-6.5,1.1l-43.2-66.6c4.1-3.4,7.7-7.6,10.3-12.3  l36.9,16c0,0.5-0.1,1-0.1,1.5c0,8.9,7.2,16.1,16.1,16.1s16.1-7.2,16.1-16.1s-7.2-16.1-16.1-16.1c-4.8,0-9.1,2.1-12,5.4l-36.9-16  c1.3-4.1,1.9-8.5,1.9-13c0-4.3-0.6-8.4-1.7-12.3l48.4-20.1c5.4,8.7,15.1,14.5,26.1,14.5c17,0,30.8-13.8,30.8-30.8  S277.3,64.3,260.4,64.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateCards);
export default __webpack_public_path__ + "static/media/rate_cards.50d013a8b88c24d51321dd44c835dbfd.svg";
export { ForwardRef as ReactComponent };